import {
  InfoModule,
  createInfoServices
} from "./chunk-OKEFYU3C.mjs";
import "./chunk-ORCS5NZH.mjs";
export {
  InfoModule,
  createInfoServices
};
